import { render, staticRenderFns } from "./ActiveWeek.vue?vue&type=template&id=500f5a9a&"
import script from "./ActiveWeek.vue?vue&type=script&lang=js&"
export * from "./ActiveWeek.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports